export const ERROR_BOUNDARY_TEXT = {
  title: '화면을 표시하지 못했습니다',
  retry: '다시 시도',
  reload: '새로 고침',
  notFoundTitle: '화면을 찾을 수 없습니다',
  notFoundDescription: '주소가 바뀌었거나 없는 화면입니다.',
  goHome: '처음으로',
  /** 로그 문구(사용자에게 보이지 않는다) */
  logRender: '화면을 그리다 오류가 났습니다',
  logRoute: '라우트 오류',
} as const;
